import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from '@montebravo.tech/design-system-icons';
import { NavbarComponent } from './navbar.component';

@NgModule({
    declarations: [NavbarComponent],
    imports: [CommonModule, MatMenuModule, MatListModule, IconComponent],
    exports: [NavbarComponent],
})
export class NavbarModule {}
